export const billings: TableModule = {
    name: "billings",
    route: "spa.system.billings",
    columns: [
        {
            name: "invoice_number",
            mobile: true,
            sortable: true
        },
        {
            name: "invoice_date",
            sortable: true,
            breakpoint: "md",
        },
        {
            name: "organisation_name",
            sortable: true
        },
        {
            name: "amount",
            sortable: true,
            truncate: false,
            mobile: true,
            sortBy: "billings.amount",
        },
        {
            name: "status",
            sortable: false,
            truncate: false,
            mobile: true,
            width: "w-[125px]",
        }
    ],
    filters: [
        {
            name: "id",
            column: "billings.id",
            type: "numeric"
        },
        {
            name: "invoice_number",
            column: "billings.invoice_number",
            type: "string",
            reduced: true
        },
        {
            name: "year",
            column: "billings.year",
            type: "numeric",
            reduced: true
        },
        {
            name: "amount",
            column: "billings.amount",
            type: "numeric"
        },
        {
            name: "organisation_name",
            column: "organisations.name",
            type: "string"
        },
        {
            name: "invoice_date",
            column: "billings.invoice_date",
            type: "date",
            reduced: "date[,]"
        },
        {
            name: "exported_at",
            column: "billings.exported_at",
            type: "exists"
        }
    ],
    quickFilters: [
        {
            name: "qf_onlyExported",
            column: "billings.exported_at",
            operator: "exists",
            value: true,
        }
    ],
    tools: [
        {
            name: "billings.export",
            color: "rose",
            ability: ["admin", "system"]
        },
    ]
}